export default __webpack_public_path__ + "static/HIVE-FS-Trailer-small-831c2524c52f93cc3b215a9ca92839db.mp4";